import { leagueFetch } from '@leagueplatform/league-fetch';
import {
  MasonryFormResponseData,
  PostMasonryFormArgs,
} from '../types/post-masonry-form';
import { formatFormFields } from './format-form-fields';
import { getMasonryRequestHeaders } from './get-masonry-request-headers';
import { POST_MASONRY_FORM } from '../constants/masonry-form-api';

export const postMasonryForm = async ({
  formId,
  formProcessorId,
  fieldNodes,
  getNodeQueryParams,
  baseEndpoint,
}: PostMasonryFormArgs): Promise<MasonryFormResponseData> => {
  const url = `${baseEndpoint || POST_MASONRY_FORM}/${formId}`;

  const body = {
    data: {
      type: 'submit-form-request',
      attributes: {
        fields: formatFormFields(fieldNodes),
        formProcessorId,
        getNodeQueryParams,
      },
    },
  };
  const headers = getMasonryRequestHeaders();

  const response = await leagueFetch(url, {
    method: 'POST',
    headers,
    allowUnauthenticated: true,
    body: JSON.stringify(body),
  });

  if (!response.ok) {
    const error = await response.json();
    throw new Error(
      `Error posting masonry form: ${error.message || 'Unknown error'}`,
    );
  }

  try {
    const responseJson: { data: MasonryFormResponseData } = await response
      .clone()
      .json();
    return responseJson.data;
  } catch (error) {
    // Handle empty response for successful status codes (200-299)
    if (response.ok) {
      return {
        id: formId,
        type: 'post-masonry-form-response',
        attributes: {
          formId,
          statusType: 'success',
        },
      };
    }
    throw error;
  }
};
